import React, { useMemo } from 'react';
import {
  StyleProvider,
  defaultBrandingData,
  AboutRelay,
} from '@relaynetwork/design-system';
import { FeedHeader } from '@app/client-config/product-group/components/feed-header/FeedHeader';

export type AboutRelayPreviewProps = {
  showMenu: boolean;
  color: string;
};

export default function AboutRelayPreview({
  showMenu = false,
  color,
}: AboutRelayPreviewProps) {
  const brandingData = useMemo(
    () => ({
      ...defaultBrandingData,
      color: color,
    }),
    [color],
  );
  return (
    <StyleProvider brandingData={brandingData}>
      <FeedHeader
        showProductGroup={false}
        productGroupName={''}
        logoUrl={''}
        color={color}
        showBanner={false}
        showLogo={false}
        showTitleBar={false}
        isPreview={true}
        showMenu={showMenu} // Only this prop matters for About Relay preview, the rest set to false/empty
      />

      <AboutRelay
        isMobile={true}
        logoUrl={'/assets/relay-logo-full_black.png'}
      />
    </StyleProvider>
  );
}
